<template>
  <div>
    <div class="content-bg-wrap">
      <div class="content-bg" />
    </div>
    <header-landing />
    <div class="header-spacer--standard" />
    <div class="container">
      <div class="row display-flex">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div
            v-if="ppa && ppa==='personal'"
            class="landing-content"
          >
            <h1>Welcome to PER App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='mental'"
            class="landing-content"
          >
            <h1>Welcome to MEN App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='vocational'"
            class="landing-content"
          >
            <h1>Welcome to VOC App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='physical'"
            class="landing-content"
          >
            <h1>Welcome to PHY App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='spiritual'"
            class="landing-content"
          >
            <h1>Welcome to SPI App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='social'"
            class="landing-content"
          >
            <h1>Welcome to SOC App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='familial'"
            class="landing-content"
          >
            <h1>Welcome to FAM App!</h1>
          </div>
          <div
            v-if="ppa && ppa==='financial'"
            class="landing-content"
          >
            <h1>Welcome to FIN App!</h1>
          </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <registration-login-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLanding from '../../components/common-apps/HeaderLanding'
import RegistrationLoginForm from '../../components/common-apps/RegistrationLoginForm'

export default {
  name: 'App',
  components: { HeaderLanding, RegistrationLoginForm },
  data () {
    return {
      ppa: ''
    }
  },
  created () {
    let path = window.location.pathname;
    if (path.includes('personal')) {
      this.ppa = 'personal'
    }
    if (path.includes('mental')) {
      this.ppa = 'mental'
    }
    if (path.includes('spiritual')) {
      this.ppa = 'spiritual'
    }
    if (path.includes('vocational')) {
      this.ppa = 'vocational'
    }
    if (path.includes('social')) {
      this.ppa = 'social'
    }
    if (path.includes('physical')) {
      this.ppa = 'physical'
    }
    if (path.includes('familial')) {
      this.ppa = 'familial'
    }
    if (path.includes('financial')) {
      this.ppa = 'financial'
    }
    this.$store.dispatch('account/tryAutoLogin')
  },
  mounted() {
    document.body.classList.add('landing-page')
  },
  destroyed () {
    document.body.classList.remove('landing-page')
  }
}
</script>

<style lang="scss">
  // Bootstrap from node_modules has container smaller
  @import '../../scss/Bootstrap/scss/bootstrap-reboot';
  @import '../../scss/Bootstrap/scss/bootstrap';
  @import '../../scss/Bootstrap/scss/bootstrap-grid';

  @import '../../scss/main';
  @import '../../scss/fonts';

</style>
